export const normalize = `
 html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  caption,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    font: inherit;
    color: inherit;
    vertical-align: baseline;
    outline: none;
  }

  body,
  input,
  button,
  select,
  textarea {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust: 100%;
    -moz-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    text-size-adjust: 100%;

  }

  input:-webkit-autofill,
  input:-webkit-autofill:focus {
    transition: background-color 600000s 0s, color 600000s 0s;
  }

  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }

  ol,
  ul {
    list-style: none;
  }

  blockquote,
  q {
    quotes: none;
  }

  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: none;
  }

  a {
    line-height: 1;
    text-decoration: none;
    transition: all 0.3s;
    will-change: transform, opacity;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  body, html {
    margin: 0;
    padding: 0;
  }

  body {
    overflow-x: hidden;
    color: #000;

    &.open-nav {
      overflow: hidden;
    }
  }

  p {
    margin: 0;
  }

  b,
  strong {
    font-weight: 700;
  }

  input,
  select,
  textarea,
  button {
    -webkit-appearance: none;
    border-radius: 0;
  }

  select {
    -webkit-appearance: menulist-button;
  }

  select::-ms-expand {
    display: none;
  }

  textarea {
    resize: none;
  }

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  img,
  picture {
    display: block;
    height: auto;
  }

  button,
  input,
  textarea {
    background: transparent;
    border: 0;
    outline: 0;
    font: inherit;
    color: inherit;
  }

  iframe {
    display: block;
    max-width: 100%;
  }

  ul, ol {
    margin: 0;
    padding: 0;
  }

  html,
  body,
  #app {
    height: 100%;
    position: relative;
    width: 100%;
  }

  body {
    font-size: 16px;
    line-height: 1.4;
    font-family: 'Lato', sans-serif;
    font-weight: 400;
    background: #fff;
    color: #000;
  }


  .wrapper {
    min-height: 100vh;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
  }

  #__next,
  main.content {
    position: relative;
  }

  main.content {
    flex: 1 0 auto;
    padding-top: 96px;
  }

  #preloader {
   position: fixed;
    width: 100%;
    height: 100%;
    background: #18181B;
    z-index: 9999;
    transition: opacity 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #preloader svg {
    width: 240px;
    height: 240px;
    letter-spacing: 0.6px;
  }

  .draggable{
    cursor: move
  }

  .loaded #preloader {
    opacity: 0;
  }

  .preloader-content {
    width: 200px;
    height: 200px;
    border-radius: 100%;
    background: linear-gradient(180deg, #2A2A2A 0%, #171717 100%);
    border: 0.833333px solid rgba(96, 96, 96, 0.3);
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #D6D6D6;
    font-weight: 600;
    font-size: 18px;
  }

  .preloader-content:before {
    content: "";
    background: linear-gradient(44.9deg, #7780e9 3%,#5a43db 22.7%, #9b4acc 43.92%, #c76268 63.12%, #de9386 82.32%, #fefbc4 100%);
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    filter: blur(16px);
    border-radius: 100%;
  }

  .svg-sprite svg,
  .svg-sprite{
    height: 0;
    width: 0;
    position: absolute;
    overflow: hidden;
  }

  .fit-cover{
    object-fit: cover;
    font-family: 'object-fit: cover;'
  }
  .fit-contain{
    object-fit: contain;
    font-family: 'object-fit: contain;'
  }
`
